import Glide from '@glidejs/glide';
export default () => {
    const glide =  new Glide('.glide', {
        type: 'carousel',
        autoplay: 4000,
        animationTimingFunc: 'linear',
        perView: 2,
        bound: true,
        animationDuration:1500,
        breakpoints: {
            1024: {
                perView: 1,
            }
        }
    });
    glide.mount();
}
